import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { granted: Boolean }

  connect() {
    if (!this.grantedValue) return

    window.opener?.postMessage({ type: "front-app-authenticated" }, window.location.origin)
    window.close()
  }
}
